export default {
    language: "ภาษาไทย",
    StripeSuccess: {
        loading: "กำลังประมวลผลการชำระเงิน...",
        successMessage: "เปิดใช้งานการสมัครสมาชิกเรียบร้อยแล้ว!",
        processingError: "การประมวลผลชำระเงินล้มเหลว โปรดติดต่อเรา",
    },
    UserDetail: {
        userInfo: {
            emailLabel: "อีเมล",
            createdAt: "สร้างเมื่อ",
            noRecord: "ไม่มีบันทึก",
            loginTime: "เวลาเข้าสู่ระบบ",
        },
        orders: {
            title: "ประวัติคำสั่งซื้อ",
            loading: "กำลังโหลด...",
            refresh: "รีเฟรช",
            orderAmount: "จำนวนเงิน",
            points: "คะแนน",
            createdAt: "สร้างเมื่อ",
            orderType: "ประเภท",
            status: "สถานะ",
            noOrders: "ไม่มีคำสั่งซื้อ",
            goToSubscription: "ซื้อคะแนน",
            freeCredit: "เครดิตฟรี",
            paidCredit: "เครดิตที่ชำระแล้ว",
            queryOrderFailed: "ไม่สามารถสอบถามคำสั่งซื้อได้",
            statusPaid: "ชำระแล้ว",
            statusPending: "รอดำเนินการ",
            statusCancelled: "ยกเลิกแล้ว",
            statusDeactivated: "ปิดการใช้งาน",
            checkoutUrlNotAvailable: "ไม่สามารถรับ URL การชำระเงินได้",
            verifyingPayment: "กำลังตรวจสอบสถานะการชำระเงิน...",
            paymentSuccess: "การชำระเงินสำเร็จ",
            paymentPending: "คำสั่งซื้อกำลังรอการชำระเงิน โปรดดำเนินการชำระเงินให้เสร็จสิ้น",
            paymentFailed: "การชำระเงินล้มเหลวหรือถูกยกเลิก",
            paymentStatus: "สถานะการชำระเงิน",
            paymentStatusDescription: "คุณได้ดำเนินการชำระเงินเสร็จสิ้นแล้วหรือไม่?",
            cancelPayment: "ยกเลิกการชำระเงิน",
            completedPayment: "ชำระเงินเสร็จสิ้น",
            warning: "คำเตือน",
            confirmCancelOrder: "คุณแน่ใจหรือไม่ว่าต้องการยกเลิกคำสั่งซื้อนี้? การกระทำนี้ไม่สามารถย้อนกลับได้",
            cancel: "ยกเลิก",
            confirm: "ยืนยัน",
            cancellingOrder: "กำลังยกเลิกคำสั่งซื้อ...",
            orderCancelledSuccess: "ยกเลิกคำสั่งซื้อแล้ว",
            cancelOrderFailed: "ไม่สามารถยกเลิกคำสั่งซื้อได้",
            checkOrderStatusFailed: "ไม่สามารถตรวจสอบสถานะคำสั่งซื้อได้",
            promptClick: "คลิกที่สถานะ \"รอดำเนินการ\" เพื่อดำเนินการชำระเงินต่อ",
        }
    },
    UserFeedback: {
        title: "เสียงจากผู้ใช้",
        feedback: "รับฟังความคิดเห็นจริงจากครีเอเตอร์และผู้เชี่ยวชาญทั่วโลกเกี่ยวกับเทคโนโลยีการประมวลผลภาพด้วย AI ของเรา",
        people: [
            {
                id: 1,
                avatar: "feedback-user-avatar-1.jpg",
                name: "คุณหลิน",
                profession: "ช่างตัดต่อวิดีโอ & ผู้สร้างคอนเทนต์",
                rating: 5,
                comment: "เจ๋งมาก! ClixMagicAI ทำงานเร็วมาก! อัปโหลดวิดีโอที่มีลายน้ำ ภายในไม่กี่นาทีคุณจะได้รับเวอร์ชันที่ไม่มีลายน้ำ คุณภาพไม่สูญเสียเลย เป็นเครื่องมือที่จำเป็นสำหรับการลบลายน้ำ!"
            },
            {
                id: 2,
                avatar: "feedback-user-avatar-2.jpg",
                name: "คุณซู",
                profession: "ผู้เชี่ยวชาญด้านโซเชียลมีเดีย",
                rating: 5,
                comment: "ClixMagicAI ช่วยกู้คลังภาพ Instagram ของฉัน! สามารถระบุลายน้ำที่ซับซ้อนได้อย่างแม่นยำ การประมวลผลขอบภาพละเอียดกว่าซอฟต์แวร์อื่นมาก และผลลัพธ์ดูเป็นธรรมชาติกว่า"
            },
            {
                id: 3,
                avatar: "feedback-user-avatar-3.jpg",
                name: "คุณเฉิน",
                profession: "ผู้ผลิตคอนเทนต์วิดีโอสั้น",
                rating: 5,
                comment: "การลบลายน้ำด้วย ClixMagicAI สะดวกมาก! ประมวลผลวัสดุ TikTok ระหว่างเดินทางไปทำงาน แล้วดาวน์โหลดเวอร์ชัน HD ทันทีที่ถึงสำนักงาน เพิ่มประสิทธิภาพเป็นสองเท่า! เป็นพรสำหรับคนทำงานด้านสื่อ"
            },
            {
                id: 4,
                avatar: "feedback-user-avatar-4.jpg",
                name: "คุณหวง",
                profession: "นักออกแบบกราฟิก & ผู้อำนวยการสร้างสรรค์ด้านภาพ",
                rating: 5,
                comment: "ในฐานะนักออกแบบ ผมพอใจมาก! เมื่อประมวลผลภาพตัวอย่างที่มีโลโก้จากลูกค้า พื้นผิวพื้นหลังได้รับการซ่อมแซมอย่างเป็นธรรมชาติ ไม่มีร่องรอยของ Photoshop ประหยัดเวลาในการตกแต่งภายหลังได้มาก"
            },
            {
                id: 5,
                avatar: "feedback-user-avatar-5.jpg",
                name: "คุณเอมิลี่",
                profession: "ฟรีแลนซ์ผู้สร้างคอนเทนต์ดิจิทัล",
                rating: 5,
                comment: "ฉันเจอสมบัติแล้ว! ราคาสมาชิกถูกกว่าผลิตภัณฑ์ลบลายน้ำอื่นๆ ในตลาดมาก แต่ให้ผลลัพธ์ที่ดีกว่า โดยเฉพาะเมื่อประมวลผลลายน้ำโปร่งใสแบบไล่ระดับ"
            },
            {
                id: 6,
                avatar: "feedback-user-avatar-6.jpg",
                name: "คุณโรเบิร์ตสัน",
                profession: "ผู้ผลิตหลักสูตรอบรมองค์กร",
                rating: 5,
                comment: "ClixMagicAI สะดวกมากเพราะไม่ต้องติดตั้ง! คอมพิวเตอร์ที่ทำงานของผมมีข้อจำกัดในการติดตั้งซอฟต์แวร์ ตอนนี้ผมสามารถประมวลผลวัสดุสำหรับหลักสูตรได้จากเบราว์เซอร์ได้ทุกที่ทุกเวลา"
            },
            {
                id: 7,
                avatar: "feedback-user-avatar-7.jpg",
                name: "คุณโจว",
                profession: "แม่บ้าน & บรรณาธิการเนื้อหาชุมชน",
                rating: 5,
                comment: "อินเทอร์เฟซง่ายมากจนแม้แต่คุณยายก็ใช้ได้! หากคุณไม่มีเวลาเรียนรู้ซอฟต์แวร์มืออาชีพอย่าง Photoshop ต้องลอง ClixMagicAI เหมาะมากสำหรับผู้ใช้มือใหม่อย่างฉัน ฮ่าๆ~"
            },
            {
                id: 8,
                avatar: "feedback-user-avatar-8.jpg",
                name: "คุณจอห์นสัน",
                profession: "ผู้วางกลยุทธ์ภาพสำหรับอีคอมเมิร์ซ",
                rating: 5,
                comment: "ClixMagicAI ทรงพลังมาก สามารถลบรูปภาพ วิดีโอ วัตถุขนาดเล็ก คน ข้อความ และอื่นๆ อีกมากมาย ฟังก์ชันครบถ้วน แนะนำให้ทุกคนลองใช้~"
            },
            {
                id: 9,
                avatar: "feedback-user-avatar-9.jpg",
                name: "คุณฟาง",
                profession: "นักถ่ายภาพมือสมัครเล่น & ผู้แบ่งปันคอนเทนต์ออนไลน์",
                rating: 5,
                comment: "ว้าว~ ในที่สุดก็ได้พบเครื่องมือลบลายน้ำที่ไม่ทำลายคุณภาพของภาพ! มหัศจรรย์เหมือนเวทมนตร์~ การแก้ไขภาพไม่ใช่ปัญหาอีกต่อไป! แนะนำอย่างยิ่ง!!!"
            },
            {
                id: 10,
                avatar: "feedback-user-avatar-10.jpg",
                name: "คุณวิลเลียมส์",
                profession: "ผู้สอนการศึกษาออนไลน์",
                rating: 5,
                comment: "ฟีเจอร์จดจำตำแหน่งลายน้ำมีประโยชน์มาก! เมื่อประมวลผลวิดีโอในชุดหลักสูตร ไม่ต้องเลือกพื้นที่ซ้ำๆ ประหยัดเวลาทำงานอย่างน้อยครึ่งชั่วโมง เพิ่มประสิทธิภาพในการเตรียมการสอนของผมอย่างมาก"
            }
        ]
    },
    Order: {
        purchasePoints: "ซื้อคะแนน",
        subtitle: "เลือกแพ็คเกจคะแนนที่เหมาะสมเพื่อใช้บริการลบลายน้ำคุณภาพสูง",
        loginReminderDesc: "เข้าสู่ระบบเพื่อเลือกและซื้อคะแนน",
        freeTag: "ฟรี",
        freePlan: "แผนฟรี",
        autoActivated: "เปิดใช้งานอัตโนมัติหลังเข้าสู่ระบบ",
        points: "คะแนน",
        autoIncluded: "ของขวัญฟรี",
        discount: "ส่วนลด",
        purchase: "ซื้อเลย",
        paymentStatusDescription: "คุณชำระเงินเสร็จแล้วหรือไม่?",
        paymentNotCompleted: "ยังไม่ได้ชำระเงิน",
        queryOrderFailed: "การตรวจสอบสถานะคำสั่งซื้อล้มเหลว",
        cancelPayment: "ยกเลิกการชำระเงิน",
        completedPayment: "ชำระเงินเสร็จสิ้น",
        warning: "คำเตือน",
        confirmCancelOrder: "คุณแน่ใจหรือว่าต้องการยกเลิกคำสั่งซื้อนี้? การกระทำนี้ไม่สามารถเปลี่ยนแปลงได้",
        cancel: "ยกเลิก",
        confirm: "ยืนยัน",
        selectProductFirst: "โปรดเลือกแพ็คเกจก่อน",
        creatingOrder: "กำลังสร้างคำสั่งซื้อ...",
        orderCreated: "สร้างคำสั่งซื้อสำเร็จ",
        createOrderFailed: "การสร้างคำสั่งซื้อล้มเหลว",
        checkoutUrlNotAvailable: "ไม่สามารถรับลิงก์การชำระเงิน",
        cancellingOrder: "กำลังยกเลิกคำสั่งซื้อ...",
        orderCancelledSuccess: "ยกเลิกคำสั่งซื้อแล้ว",
        cancelOrderFailed: "การยกเลิกคำสั่งซื้อล้มเหลว",
        verifyingPayment: "กำลังตรวจสอบสถานะการชำระเงิน...",
        paymentSuccess: "ชำระเงินสำเร็จ",
        paymentPending: "คำสั่งซื้อรอการชำระเงิน โปรดชำระเงินให้เสร็จสิ้น",
        paymentFailed: "การชำระเงินล้มเหลวหรือถูกยกเลิก",
        checkOrderStatusFailed: "การตรวจสอบสถานะคำสั่งซื้อล้มเหลว",
        quickStart: "เริ่มต้นด่วน",
        shortTerm: "ใช้งานระยะสั้น",
        recommended: "แนะนำ",
        bestValue: "คุ้มค่าที่สุด",
    },
    Login: {
        title: "เข้าสู่ระบบ",
        subtitle: "เข้าสู่ระบบด่วนด้วยบัญชีโซเชียล",
        memberTip: "เข้าสู่ระบบเพื่อใช้คุณสมบัติเพิ่มเติม",
        types: [
            {
                id: 1,
                provider: "github",
                icon: "fab fa-github",
                desc: "เข้าสู่ระบบด้วย GitHub"
            },
            {
                id: 2,
                provider: "google",
                icon: "fab fa-google",
                desc: "เข้าสู่ระบบด้วย Google"
            }
        ],
        error: {
            serverError: "เซิร์ฟเวอร์ผิดพลาด ลองอีกครั้งภายหลัง",
            networkError: "เครือข่ายผิดพลาด ตรวจสอบการเชื่อมต่อ"
        }
    },
    OAuthCallback: {
        loading: "กำลังประมวลผลคำขอเข้าสู่ระบบ",
        pleaseWait: "โปรดรอสักครู่ กำลังตรวจสอบข้อมูลเข้าสู่ระบบ...",
        error: "เข้าสู่ระบบล้มเหลว",
        backToHome: "กลับไปหน้าหลัก",
        success: "เข้าสู่ระบบสำเร็จ",
        redirecting: "กำลังเปลี่ยนเส้นทางไปหน้าหลัก..."
    },
    Nav:{
        title: "ClixMagicAI",
        logo: "logo.png",
        menu: {
            pricing: "ราคา",
            faq: "คำถาม",
        },
        login: "เข้าสู่ระบบ",
        userMenu: {
            account: "บัญชี",
            logout: "ออกจากระบบ",
            credit: "คะแนน",
            freeCredit: "ฟรี",
            paidCredit: "ซื้อแล้ว",
            nextUpdate: "อัปเดตคะแนนครั้งต่อไป",
            language: "ภาษา",
            theme: "ธีม",
        },
        userMenuIcons: {
            account: "fas fa-user-circle",
            logout: "fas fa-sign-out-alt",
            credit: "fas fa-credit-card",
            language: "fas fa-globe",
            theme: "fas fa-moon",
        },
    },
    Description:{
        title: "ClixMagicAI",
        desc: "เครื่องมือระดับมืออาชีพที่ขับเคลื่อนด้วย AI สำหรับลบลายน้ำออกจากรูปภาพและวิดีโอได้อย่างรวดเร็ว",
        fileTypes: {
            image: 'ลบลายน้ำรูปภาพ',
            pdf: 'ลบลายน้ำ PDF',
            video: 'ลบลายน้ำวิดีโอ'
        },
        marketingTags: [
            { id: "freeTrialTag", text: "ทดลองใช้ฟรีรายวัน", icon: "fa-gift" },
            { id: "imageTag", text: "ลบลายน้ำรูปภาพ", icon: "fa-image" },
            { id: "videoTag", text: "ลบลายน้ำวิดีโอ", icon: "fa-video" },
            { id: "aiPoweredTag", text: "ขับเคลื่อนด้วย AI", icon: "fa-robot" },
            { id: "noRegTag", text: "เข้าสู่ระบบและใช้งาน", icon: "fa-user-check" },
        ],
        videoPromt: "เร็วๆ นี้!",
        videoDesc: "เรากำลังพัฒนาคุณสมบัติการลบลายน้ำวิดีโอเพื่อมอบประสบการณ์ที่ดียิ่งขึ้น"
    },
    ProductAdv: {
        title: "สำรวจความสามารถอันทรงพลังของ ClixMagicAI:",
        advs: [
            {
                title: "เครื่องมือจดจำอัจฉริยะด้วย AI: ระบุตำแหน่งสิ่งรบกวนอัตโนมัติ",
                desc: "ด้วยอัลกอริทึมการเรียนรู้เชิงลึก ระบบจะจดจำลายน้ำ ข้อความ ใบหน้า และองค์ประกอบพื้นหลังในรูปภาพ/วิดีโอโดยอัตโนมัติ รองรับรูปแบบจาก Instagram, TikTok และอื่นๆ",
                beforeImage: "adv-before-1.jpg",
                afterImage: "adv-after-1.jpg",
                click: "ลบลายน้ำ"
            },
            {
                title: "ผู้เชี่ยวชาญการทำความสะอาดรูปภาพ: ลบโลโก้/วันที่อย่างรวดเร็วโดยไม่สูญเสียคุณภาพ",
                desc: "ลบลายน้ำแบรนด์ วันที่ถ่ายภาพ สติกเกอร์และสิ่งรบกวนอื่นๆ อย่างแม่นยำ AI ซ่อมแซมพื้นผิวพื้นหลังโดยอัตโนมัติ ทำให้รูปภาพดูเป็นธรรมชาติ",
                beforeImage: "adv-before-2.jpg",
                afterImage: "adv-after-2.jpg",
                click: "ลบลายน้ำ"
            },
            {
                title: "ผู้กำจัดลายน้ำเคลื่อนไหว: ลบข้อความเลื่อน/โลโก้แพลตฟอร์ม",
                desc: "ลบป้ายลอยของ YouTube ลายน้ำเคลื่อนไหวของ TikTok และข้อความเลื่อนด้วยคลิกเดียว AI ติดตามและประมวลผลทีละเฟรม ให้วิดีโอ 4K คุณภาพสูงที่ลื่นไหล",
                beforeImage: "adv-before-3.jpg",
                afterImage: "adv-after-3.jpg",
                click: "ลบลายน้ำ"
            }
        ]
    },
    Footer: {
        social: {
            title: "ติดต่อเรา",
            logo: "logo.png",
            methods:[
                {
                    icon: "x-platform-icon",
                    link: "https://x.com/ClixMagicAI"
                },
                {
                    icon: "far fa-envelope",
                    link: "mailto:clixmagicai@gmail.com",
                    text: "clixmagicai@gmail.com"
                },
            ]
        },
        termsTitle: "ข้อกำหนดทางกฎหมาย",
        terms: [
            {
                id: 1,
                title: "นโยบายความเป็นส่วนตัว",
                link: "/privacy"
            },
            {
                id: 2,
                title: "ข้อกำหนดการใช้งาน",
                link: "/terms"
            },
            {
                id: 3,
                title: "นโยบายคุกกี้",
                link: "/cookie"
            }
        ],
        copyright: "© 2025 ClixMagicAI สงวนลิขสิทธิ์"
    },
    Task: {
        image: {
            imageSupportText: 'รองรับรูปแบบ jpg, jpeg, png, webp, heic, heif ขนาดไฟล์สูงสุด 10MB',
            imageFileTooLarge: 'ขนาดไฟล์เกินขีดจำกัด (สูงสุด 10MB)',
            invalidImageType: 'รูปแบบไฟล์ไม่รองรับ โปรดอัปโหลด JPG, JPEG, PNG, WEBP, HEIC หรือ HEIF',
            imageWillCost: 'ใช้: 1 คะแนน',
            hiecSupportText: 'รูปแบบ HEIC/HEIF จะถูกแปลงเป็น PNG โดยอัตโนมัติ',
            hiecSuccess: 'แปลงรูปแบบ HEIC/HEIF สำเร็จ',
            hiecFailed: 'แปลงรูปแบบ HEIC/HEIF ล้มเหลว',
            processingImageTip: 'กำลังประมวลผลรูปภาพ โปรดรอสักครู่...',
            guide: {
                title: 'คู่มือการใช้งาน',
                step1: 'อัปโหลดรูปภาพ',
                step2: 'ระบายบริเวณลายน้ำหรือปล่อยให้ระบบตรวจจับอัตโนมัติ',
                step3: 'คลิกส่ง'
            }
        },
        common: {
            remaining: 'คะแนนคงเหลือ',
            nextUpdate: 'อัปเดตคะแนนครั้งต่อไป',
            handleError: 'เกิดข้อผิดพลาดในการประมวลผลไฟล์ ลองไฟล์อื่น',
            uploadFailed: 'อัปโหลดไฟล์ล้มเหลว',
            dragText: 'ลากไฟล์มาที่นี่หรือ',
            clickText: 'คลิกเพื่ออัปโหลด',
            loginRequired: 'โปรดเข้าสู่ระบบก่อนอัปโหลด',
            noRemainingTasks: 'คุณใช้คะแนนหมดแล้ว',
            loginNow: 'เข้าสู่ระบบเลย',
            upgradeNow: 'ซื้อคะแนนเลย',
            taskSubmitSuccess: 'ส่งงานสำเร็จ',
            taskSubmitError: 'ส่งงานล้มเหลว',
            taskRetrySuccess: 'ส่งงานใหม่สำเร็จ!',
            taskRetryError: 'ส่งงานใหม่ล้มเหลว!',
            processing: 'กำลังประมวลผล',
            submit: 'ส่ง',
            waiting: 'กำลังรอ',
            completed: 'เสร็จสิ้น',
            failed: 'ล้มเหลว',
            cancelled: 'ยกเลิก',
            url_not_found: 'ไม่พบลิงก์',
            deleted: 'ลบแล้ว',
            refreshSuccess: 'รีเฟรชรายการงานแล้ว',
            refreshFailed: 'รีเฟรชรายการงานล้มเหลว',
            deleteSuccess: 'ลบงานสำเร็จ',
            deleteFailed: 'ลบงานล้มเหลว',
            waitingForCompletion: 'โปรดรอให้งานปัจจุบันเสร็จสิ้นก่อนลองอีกครั้ง',
            loadOriginalImageFailed: 'โหลดรูปภาพต้นฉบับล้มเหลว ลองอีกครั้ง',
            downloadFailed: 'ดาวน์โหลดล้มเหลว',
            startingDownload: 'เริ่มดาวน์โหลด...',
            noTasks: 'ไม่มีงาน',
            refresh: 'รีเฟรช',
            sort: 'เรียง',
            noFilterTasks: 'ไม่มีงาน {filter}',
            compare: 'ดูเปรียบเทียบ',
            originalImage: 'ต้นฉบับ',
            processedImage: 'ที่ประมวลผลแล้ว',
            dragToCompare: '👈 ลากเพื่อเปรียบเทียบ 👉',
            cancel: "ยกเลิก",
            delete: "ลบ",
            retry: "ลองใหม่",
            download: "ดาวน์โหลด",
            createAt: "สร้างเมื่อ",
            expiredAt: "หมดอายุเมื่อ",
        },
        video: {
            videoSupportText: 'รองรับรูปแบบ mp4, mov, avi, mkv ขนาดไฟล์สูงสุด 100MB',
            videoFileTooLarge: 'ขนาดไฟล์เกินขีดจำกัด (สูงสุด 100MB)',
            invalidVideoType: 'รูปแบบวิดีโอไม่รองรับ โปรดอัปโหลด MP4, MOV, AVI หรือ MKV',
            videoWillCost: 'ใช้: 3 คะแนน',
            processingVideoTip: 'กำลังประมวลผลวิดีโอ โปรดรอสักครู่...',
            guide: {
                step1: 'อัปโหลดวิดีโอ',
                step2: 'เลือกประเภทลายน้ำและกำหนดพื้นที่',
                step3: 'คลิกส่ง'
            },
            annotationTools: 'เครื่องมือทำเครื่องหมาย',
            selectType: 'เลือกประเภท',
            deleteAnnotation: 'ลบเครื่องหมาย',
            clearAllAnnotations: 'ล้างทั้งหมด',
            annotationHelp: 'ช่วยเหลือ',
            dragTip: 'ลากเพื่อวาดพื้นที่',
            resizeTip: 'ปรับขนาดให้พอดี',
            moveTip: 'สามารถย้ายเครื่องหมายได้',
            processing: 'กำลังประมวลผล',
            submit: 'ส่ง',
            taskSubmitSuccess: 'ส่งงานสำเร็จ',
            taskSubmitError: 'ส่งงานล้มเหลว',
            retryTaskTip: 'ส่งงานใหม่สำเร็จ',
            retryFailed: 'ส่งงานใหม่ล้มเหลว',
            uploadFailed: 'อัปโหลดล้มเหลว',
            staticWatermarkDesc: 'สำหรับลายน้ำแบบคงที่ในตำแหน่งคงที่',
            normalWatermarkDesc: 'สำหรับลายน้ำแบบคงที่ทั่วไป',
            dynamicWatermarkDesc: 'สำหรับลายน้ำแบบไดนามิกที่มีการเปลี่ยนแปลง',
            moveWatermarkDesc: 'สำหรับลายน้ำที่ต้องการการเคลื่อนย้าย'
        },
    },
    Router: {
        home: "หน้าหลัก",
        terms: "ข้อกำหนดการใช้บริการ",
        privacy: "นโยบายความเป็นส่วนตัว",
        cookie: "นโยบายคุกกี้",
        user: "ศูนย์ผู้ใช้",
    },
    FAQ: {
        title: "คู่มือการใช้งานและคำถามที่พบบ่อยของ ClixMagicAI",
        prompt: "มีปัญหาหรือคำถามใดๆ ไหม? ติดต่อเราได้ตลอดเวลาที่: clixmagicai@gmail.com",
        questions: [
            {
                id : 1,
                question: "ClixMagicAI คืออะไรและทำงานอย่างไร?",
                answer: "ClixMagicAI เป็นเครื่องมือลบลายน้ำขั้นสูงที่ขับเคลื่อนด้วย AI สามารถจดจำลายน้ำในรูปภาพและวิดีโอโดยอัตโนมัติ และมีฟังก์ชันการทำเครื่องหมายตำแหน่งลายน้ำด้วยตนเอง สำหรับรูปภาพ รองรับการแปลงหลายรูปแบบและรับประกันผลลัพธ์คุณภาพสูง สำหรับวิดีโอ สามารถจัดการลายน้ำแบบคงที่ เคลื่อนไหว และแม้แต่ลายน้ำที่เปลี่ยนรูปร่าง"
            },
            {
                id : 2,
                question: "ClixMagicAI มีบริการฟรีหรือไม่?",
                answer: "ใช่ เราให้บริการพื้นฐานฟรี 10 คะแนนต่อวัน! คุณสามารถใช้ประมวลผลรูปภาพ (ใช้ 1 คะแนนต่อครั้ง) หรือวิดีโอ (ใช้ 3 คะแนนต่อครั้ง) ขณะนี้ยังไม่รองรับการซื้อคะแนนเพิ่มเติม มีเพียง 10 คะแนนฟรีที่แจกทุกวันเท่านั้น"
            },
            {
                id : 3,
                question: "ฉันสามารถซื้อคะแนนเพิ่มเติมได้หรือไม่?",
                answer: "ในขณะนี้ยังไม่รองรับการซื้อคะแนนเพิ่มเติม ผู้ใช้แต่ละคนจะได้รับเพียง 10 คะแนนฟรีต่อวัน และจะรีเฟรชอัตโนมัติในวันถัดไป"
            },
            {
                id : 4,
                question: "รองรับรูปแบบไฟล์ใดบ้าง?",
                answer: "สำหรับรูปภาพ เรารองรับรูปแบบ PNG, JPEG, JPG, WEBP, HEIC และ HEIF โดย HEIC และ HEIF จะถูกแปลงเป็น PNG โดยอัตโนมัติ สำหรับวิดีโอ รองรับหลายรูปแบบรวมถึง MP4 และ MOV"
            },
            {
                id : 5,
                question: "ข้อมูลส่วนตัวของฉันจะได้รับการปกป้องอย่างไร?",
                answer: "ที่ ClixMagicAI เราให้ความสำคัญกับความเป็นส่วนตัวของผู้ใช้อย่างมาก ไฟล์ที่อัปโหลดทั้งหมดจะถูกเข้ารหัสและลบออกโดยอัตโนมัติภายใน 24 ชั่วโมงหลังจากประมวลผลเสร็จ เราไม่เก็บไฟล์ผู้ใช้หรือข้อมูลที่เกี่ยวข้องใดๆ"
            },
            {
                id : 6,
                question: "ฉันสามารถเข้าสู่ระบบ ClixMagicAI ได้อย่างไร?",
                answer: "เรารองรับการเข้าสู่ระบบอย่างรวดเร็วผ่านบัญชี GitHub หรือ Google เพื่อความปลอดภัยของบัญชีและความสะดวกในการลงทะเบียน"
            },
            {
                id : 7,
                question: "การประมวลผลเร็วแค่ไหน?",
                answer: "ด้วยเซิร์ฟเวอร์ประสิทธิภาพสูงและอัลกอริทึม AI ที่ปรับแต่งแล้ว งานลบลายน้ำรูปภาพส่วนใหญ่สามารถเสร็จสิ้นภายใน 10 วินาที ส่วนการลบลายน้ำวิดีโอใช้เวลาเพียง 1 นาทีในกรณีที่เร็วที่สุด เวลาจริงอาจแตกต่างกันไปตามขนาดและความซับซ้อนของไฟล์"
            },
            {
                id : 8,
                question: "ผลลัพธ์หลังการประมวลผลเป็นอย่างไร?",
                answer: "โมเดล AI ของเราผ่านการฝึกฝนอย่างมาก สามารถลบลายน้ำออกจากรูปภาพและวิดีโออย่างชาญฉลาด ในขณะที่รักษาคุณภาพของเนื้อหาเดิม ไม่ว่าจะเป็นลายน้ำที่จดจำโดยอัตโนมัติหรือทำเครื่องหมายด้วยตนเอง ลายน้ำจะถูกลบออกอย่างมีประสิทธิภาพ รับประกันผลลัพธ์ที่เป็นธรรมชาติและไร้รอยต่อ"
            },
            {
                id : 9,
                question: "อายุการใช้งานของแต่ละงานคือเท่าไร?",
                answer: "เมื่องานเสร็จสิ้น ไฟล์ที่ประมวลผลแล้วจะถูกเก็บไว้บน ClixMagicAI เป็นเวลา 24 ชั่วโมงเพื่อให้ผู้ใช้ดาวน์โหลด หลังจากหมดอายุ ไฟล์จะถูกลบออกจากเซิร์ฟเวอร์ของเราโดยอัตโนมัติเพื่อปกป้องความเป็นส่วนตัวของคุณ"
            },
            {
                id : 10,
                question: "ขีดจำกัดขนาดไฟล์สูงสุดคือเท่าไร?",
                answer: "เรารับไฟล์รูปภาพขนาดสูงสุด 10MB และไฟล์วิดีโอขนาดสูงสุด 100MB ไฟล์ที่เกินขีดจำกัดนี้อาจต้องบีบอัดหรือตัดก่อนอัปโหลด"
            }
        ]
    },
    Terms: {
        "tabs": {
            "terms": "ข้อกำหนดการใช้งาน",
            "privacy": "นโยบายความเป็นส่วนตัว",
            "cookies": "นโยบายคุกกี้"
        },
        "lastUpdated": "อัปเดตล่าสุด: 20 พฤษภาคม 2025",
        "terms": {
            "sections": [
                {
                    "title": "1. บทนำ",
                    "description": "ยินดีต้อนรับสู่ ClixMagicAI การใช้บริการของเราถือว่าคุณยอมรับข้อกำหนดการใช้งานเหล่านี้ โปรดอ่านอย่างละเอียด"
                },
                {
                    "title": "2. คำอธิบายบริการ",
                    "description": "ClixMagicAI ให้บริการเครื่องมือที่ใช้ AI สำหรับลบลายน้ำออกจากรูปภาพและวิดีโอ บริการของเราเหมาะสำหรับการใช้งานที่ถูกต้องตามกฎหมายดังต่อไปนี้:",
                    "items": [
                        "การลบลายน้ำออกจากเนื้อหาของคุณเอง",
                        "การลบลายน้ำออกจากเนื้อหาที่คุณมีสิทธิ์ในการแก้ไขอย่างเหมาะสม",
                        "เพื่อวัตถุประสงค์ทางการศึกษาและการวิจัย"
                    ]
                },
                {
                    "title": "3. ความรับผิดชอบของผู้ใช้",
                    "description": "เมื่อใช้ ClixMagicAI คุณตกลงว่า:",
                    "items": [
                        "จะอัปโหลดเฉพาะเนื้อหาที่คุณเป็นเจ้าของหรือมีสิทธิ์ในการแก้ไขอย่างเหมาะสม",
                        "จะไม่ใช้บริการของเราเพื่อวัตถุประสงค์ที่ผิดกฎหมายหรือละเมิดกฎหมายใดๆ",
                        "จะไม่พยายามหลีกเลี่ยงมาตรการความปลอดภัยหรือข้อจำกัดการใช้งานของเรา",
                        "จะไม่ใช้บริการของเราเพื่อละเมิดทรัพย์สินทางปัญญาของผู้อื่น"
                    ]
                },
                {
                    "title": "4. เงื่อนไขบัญชี",
                    "description": "คุณอาจต้องสร้างบัญชีเพื่อใช้คุณสมบัติบางอย่างของบริการเรา สำหรับการเข้าสู่ระบบ คุณสามารถใช้บัญชี Google หรือ GitHub คุณต้องรับผิดชอบต่อ:",
                    "items": [
                        "การรักษาความปลอดภัยของบัญชีของคุณ",
                        "กิจกรรมทั้งหมดที่เกิดขึ้นภายใต้บัญชีของคุณ",
                        "การให้ข้อมูลบัญชีที่ถูกต้อง (รวมถึงอวตาร อีเมล ชื่อผู้ใช้ และรหัสผู้ใช้)"
                    ]
                },
                {
                    "title": "5. บริการฟรีและบริการชำระเงิน",
                    "description": "ClixMagicAI มอบโควต้าพื้นฐานฟรีและตัวเลือกการซื้อคะแนนที่ยืดหยุ่นสำหรับการเข้าถึงคุณสมบัติการลบลายน้ำของเรา:",
                    "items": [
                        { "bold": "โควต้าพื้นฐาน", "text": "ผู้ใช้แต่ละคนจะได้รับ 10 คะแนนฟรีโดยอัตโนมัติทุกวัน สามารถใช้ในการประมวลผลเนื้อหา" },
                        { "bold": "กฎการใช้คะแนน", "text": "การลบลายน้ำรูปภาพใช้ 1 คะแนนต่อการดำเนินการ การลบลายน้ำวิดีโอใช้ 3 คะแนนต่อการดำเนินการ" },
                        { "bold": "การซื้อคะแนน", "text": "คุณสามารถซื้อแพ็คเกจคะแนนสำหรับการใช้งานเพิ่มเติม คะแนนที่ซื้อทั้งหมดมีผลถาวร ไม่มีข้อจำกัดในการหมดอายุ" },
                        { "bold": "นโยบายการคืนเงิน", "text": "เนื่องจากลักษณะทันทีและเสมือนจริงของบริการดิจิทัล คะแนนที่ซื้อสำเร็จแล้วไม่สามารถคืนเงินได้" }
                    ]
                },
                {
                    "title": "6. สิทธิ์ในทรัพย์สินทางปัญญา",
                    "description": "บริการ ClixMagicAI รวมถึงซอฟต์แวร์ การออกแบบ และเนื้อหาทั้งหมดที่เราสร้างขึ้น เป็นทรัพย์สินทางปัญญาของเรา หากไม่ได้รับอนุญาต คุณไม่สามารถคัดลอก แก้ไข หรือสร้างงานต่อยอดจากบริการของเราได้"
                },
                {
                    "title": "7. ข้อจำกัดความรับผิด",
                    "description": "ClixMagicAI ให้บริการ \"ตามที่เป็น\" โดยไม่มีการรับประกันใดๆ เราไม่รับผิดชอบต่อความเสียหายใดๆ ที่เกิดจากการใช้บริการของเรา"
                },
                {
                    "title": "8. การเปลี่ยนแปลงข้อกำหนด",
                    "description": "เราอาจแก้ไขข้อกำหนดเหล่านี้ได้ทุกเมื่อ การใช้ ClixMagicAI ต่อไปหลังจากมีการเปลี่ยนแปลงข้อกำหนดถือเป็นการยอมรับข้อกำหนดที่แก้ไขของคุณ"
                },
                {
                    "title": "9. การยกเลิก",
                    "description": "เราขอสงวนสิทธิ์ในการยุติหรือระงับการเข้าถึงบริการของเราโดยทันทีโดยไม่ต้องแจ้งให้ทราบล่วงหน้า หากเราเชื่อว่าการกระทำของคุณละเมิดข้อกำหนดเหล่านี้หรือเป็นอันตรายต่อผู้ใช้รายอื่น เรา หรือบุคคลที่สาม"
                },
                {
                    "title": "10. กฎหมายที่บังคับใช้",
                    "description": "ข้อกำหนดเหล่านี้จะอยู่ภายใต้กฎหมายที่บังคับใช้ในสถานที่จดทะเบียนบริษัทของเรา โดยไม่คำนึงถึงบทบัญญัติความขัดแย้งทางกฎหมาย"
                }
            ]
        },
        "privacy": {
            "sections": [
                {
                    "title": "1. บทนำ",
                    "description": "ที่ ClixMagicAI เราให้ความสำคัญกับความเป็นส่วนตัวของคุณและมุ่งมั่นที่จะปกป้องข้อมูลส่วนบุคคลของคุณ นโยบายความเป็นส่วนตัวนี้อธิบายถึงวิธีที่เราเก็บรวบรวม ใช้ และปกป้องข้อมูลของคุณเมื่อคุณใช้เว็บไซต์และบริการของเรา การเข้าถึงเว็บไซต์ของเราหรือใช้บริการใดๆ หมายความว่าคุณยอมรับวิธีการประมวลผลข้อมูลที่อธิบายไว้ในนโยบายนี้ เราปฏิบัติตามข้อบังคับการคุ้มครองข้อมูลที่เกี่ยวข้อง"
                },
                {
                    "title": "2. ข้อมูลที่เราเก็บรวบรวม",
                    "description": "เราอาจเก็บรวบรวมข้อมูลประเภทต่อไปนี้:",
                    "items": [
                        { "bold": "ข้อมูลบัญชี", "text": "อวตารของผู้ใช้ ที่อยู่อีเมล ชื่อผู้ใช้ และรหัสผู้ใช้ที่ให้ไว้เมื่อเข้าสู่ระบบผ่าน Google หรือ GitHub" },
                        { "bold": "ข้อมูลการใช้งาน", "text": "ข้อมูลเกี่ยวกับวิธีที่คุณใช้บริการของเรา รวมถึงคุณสมบัติที่เข้าถึงและเวลาการใช้งาน" },
                        { "bold": "เนื้อหาที่อัปโหลด", "text": "รูปภาพหรือวิดีโอที่คุณอัปโหลดเพื่อประมวลผล" },
                        { "bold": "ข้อมูลการชำระเงิน", "text": "ข้อมูลการชำระเงินเมื่อซื้อการสมัครสมาชิก (ประมวลผลอย่างปลอดภัยโดยเกตเวย์การชำระเงินของบุคคลที่สาม เช่น Creem/Stripe/PayPal เราเก็บบันทึกสถานะการชำระเงินเท่านั้น)" },
                        { "bold": "ข้อมูลทางเทคนิค", "text": "ที่อยู่ IP ประเภทเบราว์เซอร์ ข้อมูลอุปกรณ์" }
                    ]
                },
                {
                    "title": "3. วิธีที่เราใช้ข้อมูลของคุณ",
                    "description": "เราใช้ข้อมูลของคุณเพื่อ:",
                    "items": [
                        { "text": "จัดหา บำรุงรักษา และปรับปรุงบริการของเรา" },
                        { "text": "ดำเนินการและทำธุรกรรมให้เสร็จสิ้น" },
                        { "text": "ส่งการแจ้งเตือนทางเทคนิคและข้อความสนับสนุน" },
                        { "text": "ตอบสนองต่อความคิดเห็นและคำถามของคุณ" },
                        { "text": "วิเคราะห์รูปแบบการใช้งานเพื่อปรับปรุงประสบการณ์ผู้ใช้ และประมวลผลข้อมูลส่วนบุคคลเฉพาะเท่าที่จำเป็นสำหรับวัตถุประสงค์ของบริการ" },
                        { "text": "ตรวจสอบให้แน่ใจว่าระยะเวลาการเก็บรักษาข้อมูลส่วนบุคคลไม่เกินระยะเวลาที่จำเป็น" },
                        { "text": "ป้องกันการฉ้อโกงหรือกิจกรรมที่ผิดกฎหมาย" }
                    ]
                },
                {
                    "title": "4. ความปลอดภัยของข้อมูล",
                    "description": "เราใช้มาตรการความปลอดภัยตามมาตรฐานอุตสาหกรรมเพื่อปกป้องข้อมูลส่วนบุคคลของคุณ:",
                    "items": [
                        { "text": "ไฟล์ที่เข้ารหัสด้วย AES-256 ในการส่งและจัดเก็บ" },
                        { "text": "ข้อมูลที่ละเอียดอ่อนจะถูกประมวลผลโดยใช้สถาปัตยกรรมแบบไม่ต้องรู้" },
                        { "text": "การตรวจสอบบันทึกความปลอดภัยประจำวันและการสแกนหาจุดอ่อน" },
                        { "text": "การเข้าถึงของพนักงานเป็นไปตามนโยบายสิทธิ์ขั้นต่ำ" }
                    ]
                },
                {
                    "title": "5. การแบ่งปันข้อมูล",
                    "description": "เราไม่ขายข้อมูลส่วนบุคคลของคุณ เราอาจแบ่งปันข้อมูลกับบุคคลต่อไปนี้:",
                    "items": [
                        { "bold": "ผู้ให้บริการ", "text": "จำกัดเฉพาะการประมวลผลข้อมูลที่จำเป็นสำหรับการให้บริการเฉพาะเท่านั้น (เช่น การจัดเก็บบนคลาวด์ของ CloundFlare เกตเวย์การชำระเงินของบุคคลที่สาม เช่น Creem/Stripe/PayPal) และอยู่ภายใต้ข้อตกลงการประมวลผลข้อมูล" },
                        { "bold": "ข้อกำหนดทางกฎหมาย", "text": "เมื่อเราได้รับหมายเรียก คำสั่งศาล หรือกระบวนการทางกฎหมายอื่นๆ ที่เกี่ยวข้อง" }
                    ]
                },
                {
                    "title": "6. สิทธิ์ของคุณ",
                    "description": "ตามกฎหมายที่บังคับใช้ในภูมิภาคของคุณ คุณอาจมีสิทธิ์ต่อไปนี้:",
                    "items": [
                        { "text": "เข้าถึงสำเนาข้อมูลส่วนบุคคลของคุณ" },
                        { "text": "แก้ไขข้อมูลที่ไม่ถูกต้องหรือไม่สมบูรณ์" },
                        { "text": "สิทธิ์ในการลบข้อมูล ('สิทธิ์ที่จะถูกลืม') เว้นแต่เรามีเหตุผลทางกฎหมายที่จะเก็บไว้" },
                        { "text": "คัดค้านหรือจำกัดการประมวลผลข้อมูลบางประเภท" },
                        { "text": "สิทธิ์ในการโอนย้ายข้อมูล ซึ่งอนุญาตให้คุณขอโอนข้อมูลของคุณ" }
                    ]
                },
                {
                    "title": "7. ความเป็นส่วนตัวของเด็ก",
                    "description": "บริการของเราไม่ได้มีไว้สำหรับเด็กอายุต่ำกว่า 16 ปี ตามมาตรา 8 ของข้อบังคับทั่วไปว่าด้วยการคุ้มครองข้อมูล (GDPR) ความยินยอมสำหรับเด็กอายุต่ำกว่า 16 ปีจะต้องได้รับจากพ่อแม่หรือผู้ปกครอง หากคุณทราบว่าเด็กอายุต่ำกว่า 16 ปีได้ให้ข้อมูลส่วนบุคคลแก่เรา โปรดติดต่อเราทันทีที่ clixmagicai@gmail.com"
                },
                {
                    "title": "8. การเปลี่ยนแปลงนโยบายนี้",
                    "description": "เราอาจปรับปรุงนโยบายความเป็นส่วนตัวนี้เป็นครั้งคราวเพื่อสะท้อนการเปลี่ยนแปลงในเทคโนโลยี ข้อบังคับ หรือแนวทางปฏิบัติทางธุรกิจของเรา การเปลี่ยนแปลงใดๆ จะถูกโพสต์บนหน้านี้และวันที่แก้ไขจะได้รับการอัปเดต"
                },
                {
                    "title": "9. ติดต่อเรา",
                    "description": "หากคุณมีคำถามใดๆ เกี่ยวกับนโยบายความเป็นส่วนตัวนี้ โปรดติดต่อเราที่ clixmagicai@gmail.com หากคุณเชื่อว่าข้อมูลของคุณถูกประมวลผลอย่างไม่เหมาะสมหรือหากคุณมีข้อกังวลอื่นๆ อย่าลังเลที่จะติดต่อเราได้ตลอดเวลา"
                }
            ]
        },
        "cookies": {
            "sections": [
                {
                    "title": "1. คุกกี้คืออะไร",
                    "description": "คุกกี้คือไฟล์ข้อความขนาดเล็กที่วางไว้บนคอมพิวเตอร์หรืออุปกรณ์มือถือของคุณเมื่อคุณเยี่ยมชมเว็บไซต์ต่างๆ คุกกี้ช่วยให้เว็บไซต์จดจำอุปกรณ์ของคุณและจำได้ว่าคุณเคยเยี่ยมชมไซต์มาก่อนหรือไม่"
                },
                {
                    "title": "2. เราใช้คุกกี้อย่างไร",
                    "description": "ClixMagicAI ใช้คุกกี้เพื่อวัตถุประสงค์หลายประการ:",
                    "items": [
                        { "bold": "คุกกี้ที่จำเป็น", "text": "จำเป็นสำหรับฟังก์ชันพื้นฐานของเว็บไซต์ของเรา (เช่น การจัดการเซสชันและคุณสมบัติความปลอดภัย)" },
                        { "bold": "คุกกี้การตั้งค่า", "text": "จดจำการตั้งค่าและการกำหนดค่าของคุณเพื่อปรับปรุงประสบการณ์ของคุณ เช่น การจดจำอวตาร ชื่อผู้ใช้ และอื่นๆ หลังจากเข้าสู่ระบบด้วย Google หรือ GitHub" },
                        { "bold": "คุกกี้การวิเคราะห์", "text": "ช่วยให้เราเข้าใจว่าผู้เยี่ยมชมมีปฏิสัมพันธ์กับเว็บไซต์ของเราอย่างไร เราใช้ข้อมูลนี้เพื่อปรับปรุงเว็บไซต์และบริการของเรา คุกกี้เหล่านี้ไม่เก็บรวบรวมข้อมูลที่สามารถระบุตัวผู้เยี่ยมชมได้" },
                        { "bold": "คุกกี้การตลาด", "text": "ให้โฆษณาที่เกี่ยวข้องกับความสนใจของคุณโดยการติดตามพฤติกรรมการเรียกดูของคุณ" }
                    ]
                },
                {
                    "title": "3. ประเภทของคุกกี้ที่เราใช้",
                    "subsection": [
                        {
                            "title": "3.1 คุกกี้ที่จำเป็น",
                            "description": "คุกกี้เหล่านี้จำเป็นสำหรับการทำงานที่เหมาะสมของเว็บไซต์ คุกกี้เหล่านี้เปิดใช้งานฟังก์ชันหลัก เช่น ความปลอดภัย การจัดการเครือข่าย และการเข้าถึงบัญชี (รวมถึงการเข้าสู่ระบบด้วย Google และ GitHub) คุณสามารถตั้งค่าเบราว์เซอร์ของคุณให้บล็อกคุกกี้เหล่านี้ได้ แต่บางส่วนของเว็บไซต์อาจไม่ทำงานอย่างถูกต้อง"
                        },
                        {
                            "title": "3.2 คุกกี้ประสิทธิภาพและการวิเคราะห์",
                            "description": "คุกกี้เหล่านี้เก็บรวบรวมข้อมูลที่ไม่ระบุตัวตนที่ช่วยให้เราเข้าใจว่าผู้เยี่ยมชมมีปฏิสัมพันธ์กับเว็บไซต์ของเราอย่างไร เราใช้ข้อมูลนี้เพื่อปรับปรุงเว็บไซต์และบริการของเรา คุกกี้เหล่านี้ไม่เก็บรวบรวมข้อมูลที่สามารถระบุตัวผู้เยี่ยมชมได้"
                        },
                        {
                            "title": "3.3 คุกกี้ฟังก์ชัน",
                            "description": "คุกกี้เหล่านี้ช่วยให้เว็บไซต์ของเราจดจำตัวเลือกที่คุณทำ (เช่น การตั้งค่าภาษาหรือสถานะการเข้าสู่ระบบ) เพื่อมอบคุณสมบัติที่ปรับแต่งและปรับปรุงให้ดีขึ้น เช่น การจดจำสถานะการเข้าสู่ระบบของคุณผ่าน Google หรือ GitHub"
                        },
                        {
                            "title": "3.4 คุกกี้การกำหนดเป้าหมายและโฆษณา",
                            "description": "คุกกี้เหล่านี้ใช้เพื่อแสดงโฆษณาที่เกี่ยวข้องกับผู้เยี่ยมชมและติดตามประสิทธิภาพของแคมเปญโฆษณาของเรา โปรดทราบว่าเนื่องจากเว็บไซต์ของเราพึ่งพาการเข้าสู่ระบบของบุคคลที่สามเป็นหลัก (Google และ GitHub) คุกกี้ประเภทนี้จึงใช้เพื่อปรับปรุงประสบการณ์ผู้ใช้เป็นหลัก ไม่ใช่เพื่อการตลาดโดยตรง"
                        }
                    ]
                },
                {
                    "title": "4. การจัดการคุกกี้",
                    "description": "คุณสามารถควบคุมและจัดการคุกกี้ได้หลายวิธี เว็บเบราว์เซอร์ส่วนใหญ่อนุญาตให้คุณจัดการการตั้งค่าคุกกี้ของคุณ คุณสามารถ:",
                    "items": [
                        { "text": "ลบคุกกี้จากอุปกรณ์ของคุณ" },
                        { "text": "บล็อกคุกกี้โดยเปิดใช้งานการตั้งค่าในเบราว์เซอร์ของคุณที่อนุญาตให้คุณปฏิเสธคุกกี้ทั้งหมดหรือบางส่วน" },
                        { "text": "ตั้งค่าเบราว์เซอร์ของคุณให้แจ้งเตือนคุณเมื่อคุณได้รับคุกกี้" }
                    ]
                },
                {
                    "title": "5. คุกกี้ของบุคคลที่สาม",
                    "description": "คุกกี้บางตัวถูกวางโดยบุคคลที่สามบนเว็บไซต์ของเรา บุคคลที่สามเหล่านี้อาจรวมถึงบริการวิเคราะห์ (เช่น Google Analytics) และเครือข่ายโฆษณา เนื่องจากวิธีที่คุกกี้ทำงาน (คุกกี้สามารถเข้าถึงได้โดยฝ่ายที่ตั้งค่าเท่านั้น) เราไม่สามารถควบคุมการใช้คุกกี้ของบุคคลที่สามเหล่านี้หรือเข้าถึงได้ สำหรับผู้ใช้ที่เข้าสู่ระบบผ่าน Google และ GitHub เราจะดูแลให้มั่นใจว่าเราปฏิบัติตามแนวทางความเป็นส่วนตัวของแพลตฟอร์มเหล่านั้นในการจัดการข้อมูลที่เกี่ยวข้อง"
                },
                {
                    "title": "6. การอัปเดตนโยบายคุกกี้นี้",
                    "description": "เราอาจอัปเดตนโยบายคุกกี้นี้เป็นครั้งคราวเพื่อสะท้อนการเปลี่ยนแปลงในเทคโนโลยี ข้อบังคับ หรือแนวทางปฏิบัติทางธุรกิจของเรา การเปลี่ยนแปลงใดๆ จะถูกโพสต์บนหน้านี้และวันที่แก้ไขจะได้รับการอัปเดต"
                },
                {
                    "title": "7. ติดต่อเรา",
                    "description": "หากคุณมีคำถามใดๆ เกี่ยวกับการใช้คุกกี้ของเรา โปรดติดต่อเราที่ clixmagicai@gmail.com"
                }
            ]
        }
    },
}